var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 4c.276 0 .512.098.707.293A.963.963 0 0 1 20 5v14a.963.963 0 0 1-.293.707A.963.963 0 0 1 19 20H5a.963.963 0 0 1-.707-.293A.963.963 0 0 1 4 19V5c0-.276.098-.512.293-.707A.963.963 0 0 1 5 4h1.336v2c0 .276.098.512.293.707A.963.963 0 0 0 7.336 7a.963.963 0 0 0 .707-.293A.963.963 0 0 0 8.336 6V4h7.328v2c0 .276.098.512.293.707a.963.963 0 0 0 .707.293.963.963 0 0 0 .707-.293.963.963 0 0 0 .293-.707V4H19zM9 17.664V15H6.336v2.664H9zM9 13v-2.664H6.336V13H9zm4.336 4.664V15h-2.672v2.664h2.672zm0-4.664v-2.664h-2.672V13h2.672zm4.328 4.664V15H15v2.664h2.664zm0-4.664v-2.664H15V13h2.664z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.18ba2966646a6732e762620430d80fca.svg";
export { ForwardRef as ReactComponent };